import React from 'react';
import { Button, Header, Icon, Modal } from 'semantic-ui-react'



const ModalFinSession=({showModal, onRenovarSession})=>{
	 
	return (
	
        
        <Modal open={showModal} size='tiny'>
            <Header icon="log out" content="Fin de Sesión" />
            <Modal.Content>
                <p>Esta por alcanzar el tiempo límite de inactividad permitido dentro del Sistema.</p>
                <p>Si desea continuar dentro del Sistema de clic en el botón de continuar. </p>
            
            </Modal.Content>
            <Modal.Actions>
               
              <Button color='green' onClick={onRenovarSession} inverted>
                <Icon name='checkmark' /> Continuar
              </Button>
            </Modal.Actions>
          </Modal>
	
	);
};
export default ModalFinSession;